/**
 *  Vue 2 state around an AI client from `@cglt/ai/client`. Pass the client, or a
 *  function that receives the component and returns one.
 *
 *    mixins: [aiGenerationMixin({ client: vm => createAIClient({ transport }) })]
 *    const result = await this.aiGenerate(request)   // rethrows AIError
 *
 *  Templates can read `aiGenerating`, `aiGeneration.error` and `aiGeneration.lastResult`.
 */
export function aiGenerationMixin(options) {
	if (!options || !options.client) {
		throw new Error('aiGenerationMixin requires { client }')
	}

	return {
		data() {
			return {
				aiGeneration: { pending: 0, error: null, lastResult: null },
			}
		},
		computed: {
			aiGenerating() {
				return this.aiGeneration.pending > 0
			},
		},
		created() {
			// Kept out of data() so Vue does not make the client reactive.
			this.$_aiClient = typeof options.client === 'function' ? options.client(this) : options.client
		},
		methods: {
			async aiGenerate(request) {
				this.aiGeneration.pending += 1
				this.aiGeneration.error = null
				try {
					const result = await this.$_aiClient.generate(request)
					// A frozen copy keeps Vue from deep-observing generated data.
					this.aiGeneration.lastResult = Object.freeze({ ...result })
					return result
				} catch (error) {
					this.aiGeneration.error = error
					throw error
				} finally {
					this.aiGeneration.pending -= 1
				}
			},
		},
	}
}
